import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=129bfa87&scoped=true"
import script from "./Talent.vue?vue&type=script&lang=js"
export * from "./Talent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129bfa87",
  null
  
)

export default component.exports